import apiClient from '@/services/api'

export default {
  async getUser(_, { id }) {
    try {
      const { data } = await apiClient.get(`/api/user/${id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.profile
    } catch (error) {
      throw error.message
    }
  },
  async getTerminalUsers({ rootState }, { page, size }) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.get('api/user/terminal', {
        params: { page, size, project_id }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async updateLogo({ rootState }, { id, file_id }) {
    try {
      const { data } = await apiClient.put(`/api/user/${id}/photo`, {
        file_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async updateUser(_, { user }) {
    try {
      const { data } = await apiClient.post('/api/user/update', {
        ...user
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.photo_url
    } catch (error) {
      throw error.message
    }
  },

  async createTerminalUser({ rootState }, { user }) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.post('/api/project/tablet_user/create', {
        ...user,
        project_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async resetTerminalUserPassword(_, { id, password }) {
    try {
      const { data } = await apiClient.patch(`/api/user/${id}/change_password`, {
        password
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async deleteUser(_, { id }) {
    try {
      const { data } = await apiClient.delete(`/api/user/${id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async getInvitations({ rootState }, { page, size }) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.get(`api/project/${project_id}/invitation`, {
        params: { page, size }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async inviteUser({ rootState }, { user }) {
    const project_id = rootState.applicationState.currentProject.id
    const author_id = rootState.applicationState.associate.id

    try {
      const { data } = await apiClient.post('/api/invite_user_to_project', {
        ...user,
        project_id,
        author_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },

  async deleteInvite(_, { id }) {
    try {
      const { data } = await apiClient.delete('/api/invite_user_to_project', {
        params: { id }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },

  async getAssociateScheduleGaps({ rootState }, { role_name } = {}) {
    const project_id = rootState.applicationState.currentProject.id

    try {
      const { data } = await apiClient.get('/api/associate/schedule/gaps', {
        params: {
          project_id,
          ...(role_name ? { role_name } : {})
        }
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data.gaps
    } catch (error) {
      throw error.message
    }
  }
}
